import { render, staticRenderFns } from "./chemUpdateDbUploadDetail.vue?vue&type=template&id=1faa93ae"
import script from "./chemUpdateDbUploadDetail.vue?vue&type=script&lang=js"
export * from "./chemUpdateDbUploadDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1faa93ae')) {
      api.createRecord('1faa93ae', component.options)
    } else {
      api.reload('1faa93ae', component.options)
    }
    module.hot.accept("./chemUpdateDbUploadDetail.vue?vue&type=template&id=1faa93ae", function () {
      api.rerender('1faa93ae', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/mdm/mam/form/chemUpdateDbUploadDetail.vue"
export default component.exports